import * as Yup from "yup";

export default () => {
  return Yup.object().shape({
    category: Yup.number()
      .nullable()
      .required("US.COLLECTION.VALIDATIONS:REQUIRED.CATEGORY_IS_REQUIRED"),
  });
};
